<template>
  <app-layout title="Transactions">
    <template #header>
      <h1 class="text-3xl font-bold tracking-tight text-white">
        {{ __('Transactions') }}
      </h1>
    </template>

    <dynamic-table
        :resource="transactions"
        :name="__('Transactions')"
        :columns="['ID', 'Description', 'Price', 'Created At']"
    >
      <template v-slot="{ data: transactions, icons }">
        <tr v-for="transaction in transactions">
          <td class="text-sm font-semibold text-gray-400">#{{ transaction.tid }}</td>
          <td class="text-sm font-medium text-gray-500">
            <span class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">{{ transaction.description }}</span>
          </td>
          <td class="text-sm font-medium text-gray-500">{{ price(transaction.amount) }}</td>
          <td class="text-sm font-medium text-gray-500">{{ date(transaction.created_at) }}</td>
<!--          <td class="column-actions">-->
<!--            <inertia-link :href="route('license.show', license)">-->
<!--              <component :is="icons.edit" class="icon icon-edit"/>-->
<!--            </inertia-link>-->
<!--          </td>-->
        </tr>
      </template>
    </dynamic-table>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import DynamicTable from "@/Misc/Table/DynamicTable";
export default {
  name: "List",
  components: {DynamicTable, AppLayout},
  props: ['transactions']
}
</script>